export default __webpack_public_path__ + "static/media/joys500_product.f79584ef.png";